var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0401 8.81001C19.3987 8.81001 20.5001 7.70863 20.5001 6.35001C20.5001 4.99139 19.3987 3.89001 18.0401 3.89001C16.6814 3.89001 15.5801 4.99139 15.5801 6.35001C15.5801 7.70863 16.6814 8.81001 18.0401 8.81001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.96001 8.81001C8.31863 8.81001 9.42 7.70863 9.42 6.35001C9.42 4.99139 8.31863 3.89001 6.96001 3.89001C5.60139 3.89001 4.5 4.99139 4.5 6.35001C4.5 7.70863 5.60139 8.81001 6.96001 8.81001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.0401 21.1099C19.3987 21.1099 20.5001 20.0086 20.5001 18.6499C20.5001 17.2913 19.3987 16.1899 18.0401 16.1899C16.6814 16.1899 15.5801 17.2913 15.5801 18.6499C15.5801 20.0086 16.6814 21.1099 18.0401 21.1099Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96001 21.1099C8.31863 21.1099 9.42 20.0086 9.42 18.6499C9.42 17.2913 8.31863 16.1899 6.96001 16.1899C5.60139 16.1899 4.5 17.2913 4.5 18.6499C4.5 20.0086 5.60139 21.1099 6.96001 21.1099Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.59bba3e061812b05ce25131aa6a36975.svg";
export { ForwardRef as ReactComponent };